module.exports = __webpack_public_path__ + "static/media/right-4926156_1280.a6217f86.jpg";